export type ExamDeliveryMethod = 'FaceToFace' | 'Online' | 'EExamFaceToFace'

export const EXAM_DELIVERY_METHOD_OPTIONS: Array<{value: ExamDeliveryMethod; label: string}> = [
  {value: 'FaceToFace', label: 'Yüz yüze'},
  {value: 'Online', label: 'Çevrim içi'},
  {value: 'EExamFaceToFace', label: 'E-sınav (yüz yüze)'},
]

export const getExamDeliveryMethodLabel = (value?: ExamDeliveryMethod | string | null): string => {
  if (!value) {
    return ''
  }

  return EXAM_DELIVERY_METHOD_OPTIONS.find((option) => option.value === value)?.label || String(value)
}
